import { Controller } from "@hotwired/stimulus"

// Generic tab switcher: `tab` buttons (data-tab) show the `panel` with the
// same data-tab. The active / inactive tab styling defaults to the event-plan
// slideover's teal chips; pass data-slideover-tabs-active-class /
// -inactive-class to restyle (the guest rows use underline tabs).
export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = { active: { type: String, default: "basic" } }

  connect() {
    this.showTab(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activeValue = tab
    this.showTab(tab)
  }

  showTab(tabName) {
    const on = this.hasActiveClass ? this.activeClasses : ["bg-teal-100", "text-teal-500", "shadow-sm"]
    const off = this.hasInactiveClass ? this.inactiveClasses : ["text-gray-700"]

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === tabName
      tab.classList.remove(...(active ? off : on))
      tab.classList.add(...(active ? on : off))
      tab.setAttribute("aria-selected", active)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })
  }
}
